import React, { useEffect, useState } from 'react'
import Accordian from "../components/Accordian/Accordian"
import Tabs from "../components/Tabs";
import SoftBox from "components/SoftBox";
import AdminPrompt from './adminprompts/AdminPrompt';
import CustomPrompt from './customPrompts/CustomPrompt';
import Promptlabels from './promptlabels/CustomPrompt';
import ModelPrompts from './customPrompts/ModelPrompts/Create';
import ModelPromptslabels from "./promptlabels/ModelPrompts/Create";
import PromptLabels from "./promptlabels/CustomPrompt";
import SoftButton from 'components/SoftButton';
import { useAgencyInfo } from 'context/agency';
import useRequest from 'hook/useRequest';
import { ReqMethods } from 'enums';
import { useCreateManagePrompt } from 'queries/promptCategories';
import JobRoles from './JobRoles';
import Sectors from './Sectors';

const { POST } = ReqMethods;

function index() {
  const [agency] = useAgencyInfo();
  const request = useRequest();
  const { mutateAsync: createManagePrompt } = useCreateManagePrompt();

  const refresh = () => {
    setTabsData([]);

    setTimeout(() => {
      setTabsData([
        { label: 'Admin Task', content: <AdminPrompt /> },
        { label: 'Partner Tasks', content: <CustomPrompt refresh={refresh} custompromptcreateModel={() => customepromptmodel()} /> },
      ]);
    }, 2000);
  }

  const [tabsData, setTabsData] = useState([
    { label: 'Admin Task', content: <AdminPrompt /> },
    { label: 'Partner Tasks', content: <CustomPrompt refresh={refresh} custompromptcreateModel={() => customepromptmodel()} /> },
  ]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openModelPromptLabel, setopenModelPromptLabel] = useState(false);
  const [isSubCategoryModel, setIsSubCategoryModel] = useState(false);

  const openModelView = () => {
    setIsModalOpen(true);
  };
  const handleclose = () => {
    setIsModalOpen(false);
    setopenModelPromptLabel(false);
  }
  const promptcreate = () => {
    setopenModelPromptLabel(true);
  }
  const customepromptmodel = () => {
    openModelView();
  }
  const savedata = async (formData) => {
    setTabsData([]);
    const updatedFormData = { ...formData, agency_id: agency._id };
    const payload = updatedFormData;
    const { response } = await createManagePrompt(payload)
    if (response) {
      handleclose();
      setIsModalOpen(false);
      refresh();
    }
  }

  const savedataPromptLabel = async (formData) => {
    setTabsData([]);
    const updatedFormData = {
      ...formData,
      agency_id: agency._id,
      type: "agency"
    };
    const payload = updatedFormData;
    // Inlined rather than queries/promptLabels.js's useCreatePromptLabel -
    // that hook doesn't pass toaster, and this call site always has, so
    // reusing it would silently drop the success/error toast.
    const { response } = await request(POST, "/promptslabel/create", {
      payload,
      toaster: true,
    });
    console.log('responseresponseresponse', response)
    if (response) {
      handleclose();
      setIsModalOpen(false);
    }
    refresh();

  }


  return (

    <div className='pt-0 p-5'>
      <div style={{ width: "100%", position: "relative" }} className='d-flex justify-content-between'>
        <h2 style={{ width: "50%" }} className='px-2'>Tasks</h2>
      </div>
      <div style={{ margin: "0px 0px 20px 0px" }}>
        <Tabs tabsData={tabsData} />
      </div>

      {isModalOpen && (
        <ModelPrompts data={null} modelfunctionality={savedata} openModel={isModalOpen} onclosemodel={handleclose} />
      )}
      {openModelPromptLabel && (
        <ModelPromptslabels data={null} modelfunctionality={savedataPromptLabel} openModel={openModelPromptLabel} onclosemodel={handleclose} />
      )}
    </div>
  )
}

export default index

